import { render } from "./Content.vue?vue&type=template&id=71dca164"
const script = {}

import exportComponent from "D:\\Belajar Koding\\VueJS\\personal-finance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__